<div class="layout-wrapper  layout-menu-static 
layout-rtl layout-menu-light layout-topbar-blue" [ngClass]="{
'layout-menu-active': menuActive,
'layout-menu-mobile-active': mobileMenuActive,
'layout-topbar-mobile-active': mobileTopbarActive}">

    <app-topbar (companyLoaded)="menuComponent.loadGroups()"></app-topbar>
    <side-menu class="sideMenu" (activeItem)="activeItem($event)" (mouseenter)="onMenuMouseEnter($event)"  (mouseleave)="onMainMenuLeave()"
   ></side-menu>
    <div class="menu-wrapper" (click)="onMenuClick($event)"  (mouseleave)="openCloseMenu($event)">
        <div class="layout-menu-container">
            <app-menu   #menuComponent [activeMenuItem]="activeMenuItem" ></app-menu>

        </div>
    </div>


    <div class="layout-main">
        <div class="progressContainer">
            <p-progressBar mode="indeterminate" *ngIf="isLoading$ | async"></p-progressBar>
        </div>
        <div class="layout-content" [ngClass]="{'pb-0': isHomeComponent()}">
            <div class="card" [ngClass]="isHomeComponent() ? 'p-0 sm:p-0' : 'p-0 sm:p-3'">
                <router-outlet></router-outlet>
            </div>
        </div>
        <contact-us class="fixed left-0 bottom-0 m-4 hidden md:flex"
            [ngClass]="{'mb-8': isHomeComponent()}"></contact-us>
    </div>

    <div *ngIf="mobileMenuActive" class="layout-mask modal-in"></div>
</div>

<dynamic-popup #popup></dynamic-popup>

<!------ SIDE BER ------>
<p-sidebar (onHide)="removeSideBar()" [(visible)]="visibleSidebar" position="right" [baseZIndex]="10000"
    [styleClass]="sidebarStyleClass">
    <ng-container [ngTemplateOutlet]="contentSideBar" *ngIf="visibleSidebar"></ng-container>
</p-sidebar>
